// extracted by mini-css-extract-plugin
module.exports = {"privacyEdit":"PrivacyEdit_privacyEdit__1amDH","save":"PrivacyEdit_save__3cUl5"};